<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <div slot="header">
        <i class="fa fa-list mr-2"></i>
        <strong>Liste des chargements des fichiers</strong>
        <div class="card-header-actions">
          <b-link class="card-header-action btn-minimize" v-b-toggle.collapse2>
            <span class="when-opened"><i class="icon-arrow-down"></i></span>
            <span class="when-closed"><i class="icon-arrow-up"></i></span>
          </b-link>
        </div>
      </div>
      <b-collapse id="collapse2" visible>
        <b-card-body>
          <b-row>
            <b-col sm="6">
              <b-row class="mb-1">
                <b-col sm="3">
                  <label for="type"><strong>Statut : </strong></label>
                </b-col>
                <b-col sm="9">
                  <b-form-select v-model="statusId" :options="statusOptions" :class="{hasError: errors.statusId !== ''}">
                    <template v-slot:first>
                      <b-form-select-option :value="''" disabled>-- Choisir un statut --</b-form-select-option>
                    </template>
                  </b-form-select>
                  <span class="field-error inline mr-1 float-right">{{ errors.statusId }}</span>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="6">
              <b-row class="mb-1">
                <b-col sm="3">
                  <label for="type"><strong>Type : </strong></label>
                </b-col>
                <b-col sm="9">
                  <multiselect selectLabel='Appuyer sur entrer pour sélectionner' selectedLabel='Sélectionné' deselectLabel='Appuyer sur entrer pour désélectionner' :close-on-select="true" v-model="selectedTypes" tag-placeholder="Choisissez un type" placeholder="Choisissez un type" label="name" track-by="code" :options="typeOptions" :multiple="true" :taggable="true" :class="{hasError: errors.selectedTypes !== ''}"></multiselect>
                  <span class="field-error">{{ errors.selectedTypes }}</span>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-row>
                <b-col md="3" class="mt-2">
                  <span>Chargement fichier :</span>
                </b-col>
                <b-col md="7">
                  <b-form-group label-for='nom_fichier'>
                    <b-form-file placeholder="Joindre un fichier"
                                 class="file-input"
                                 drop-placeholder="Déposer le fichier ici..."
                                 browse-text="Parcourir"
                                 :state="errors.attachment !== '' ? false : null"
                                 @change="addFile($event)">
                    </b-form-file>
                    <span class="field-error">{{ errors.attachment }}</span>
                    <b-form-text id="file-help">Fichier CSV contenant les colonnes suivantes dans l'ordre : Date chargement, NIR, nom (NSI), prenom (NSI), Abandon, Trt, Type, N°Evt, N°Psi, Date début, Date fin, Montant IJSS...</b-form-text>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-button type="enter" @click.prevent="importFile" size="md" variant="primary">
                    <i class="fa fa-upload"></i> Importer
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="6">
              <b-row class="mb-1">
                <b-col sm="3">
                  <label for="type"><strong>Commentaire à mettre en Post-it : </strong></label>
                </b-col>
                <b-col sm="9">
                  <b-form-textarea
                    id="textarea"
                    v-model="commentaire"
                    placeholder="Entrez votre commentaire..."
                    rows="3"
                    max-rows="6"
                    :state="errors.commentaire !== '' ? false : null"
                  ></b-form-textarea>
                  <span class="field-error inline mr-1 float-right">{{ errors.commentaire }}</span>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <v-client-table v-if="dataIsReady" class="mt-4" :columns="columns" :data="items" :options="options">
            <div v-if="props.row.date_traitement" slot="date_traitement" slot-scope="props" class="slot-date">
              <span class="badge badge-success p-2">{{ formatDate(props.row.date_traitement) }}</span>
            </div>
            <div v-if="props.row.nom_gestionnaire" slot="nom_gestionnaire" slot-scope="props">
              {{ props.row.nom_gestionnaire }} {{ props.row.prenom_gestionnaire }}
            </div>
            <div v-if="props.row.min_date_periode" slot="min_date_periode" slot-scope="props" class="slot-date">
              {{ formatDate(props.row.min_date_periode) }}
            </div>
            <div v-if="props.row.max_date_periode" slot="max_date_periode" slot-scope="props" class="slot-date">
              {{ formatDate(props.row.max_date_periode) }}
            </div>
            <div slot="nom_fichier" slot-scope="props" class="slot-date">
              <span class="clickable" @click="download(props.row)">{{ props.row.nom_fichier }} <i class="fa fa-download"></i></span>
            </div>
            <div slot="nb_lignes_ok" slot-scope="props">
              <span class="badge badge-success p-2 mr-2" v-if="props.row.nb_lignes_ok !== 0"> {{ props.row.nb_lignes_ok }} OK </span>
              <span class="badge badge-warning p-2" v-if="props.row.nb_lignes_ok !== 0 && props.row.nb_lignes_ok < props.row.nb_lignes_total"> {{ (props.row.nb_lignes_total * 1) - (props.row.nb_lignes_ok * 1)  }} KO</span>
              <span class="badge badge-danger p-2" v-if="props.row.nb_lignes_ok === 0">{{ props.row.nb_lignes_total }} KO</span>
            </div>
            <div slot="action" slot-scope="props">
              <b-button v-if="props.row.rapport_script_opc_module_prev.length > 0" type="button"
                        @click.prevent="seeErrors(props.row)" class="badge badge-info mr-3 p-2">
                <i class="fa fa-eye"></i> Voir
              </b-button>
            </div>
          </v-client-table>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-modal size="xl" centered scrollable id="modal-rapport" ref="modal-rapport" title="Rapport du traitement du fichier">
      <h5>Nombre de lignes total : <b>{{ nbLigneTotal }}</b></h5>
      <h5>Nombre de lignes OK : <b>{{ !nbLigneOk ? '0' : nbLigneOk }}</b></h5>
      <ul class="mt-3">
        <li v-for="(error, key) in rapportErrors" :key="key" v-html="error"></li>
      </ul>
      <template v-slot:modal-footer>
        <div class="w-100 text-right">
          <button type="button" class="btn btn-secondary mr-1" @click="$bvModal.hide('modal-rapport')">Fermer</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import {hasRule, espaceGestionRules} from "@/utils/rulesHelper";
  import {downloadFile, isEmpty} from "@/utils/fileHelper";
  // import {downloadFile, isEmpty, nl2br, getIconSrc as getIconSrcMain, getReadableFileSize as getReadableFileSizeMain, permittedExtension, guardedFile} from "@/utils/fileHelper";
  import moment from 'moment';
  import Multiselect from 'vue-multiselect';

  export default {
    name: "script_opc_purge_traite",
    components: {
      Multiselect,
    },
    data() {
      return {
        rules: espaceGestionRules,
        dataIsReady: false,
        attachment: null,
        statusId: '',
        commentaire: '',
        allStatus: [],
        statusOptions: [],
        allTypes: [],
        typeOptions: [],
        selectedTypes: [],
        selectedTypeIds: [],
        rapport: [],
        nbLigneOk: null,
        nbLigneTotal: null,
        rapportErrors: [],
        errors: {
          attachment: '',
          statusId: '',
          commentaire: '',
          selectedTypes: '',
        },
        columns: ['date_traitement', 'nom_gestionnaire', 'profil_gestionnaire', 'min_date_periode', 'max_date_periode', 'nom_fichier', 'nb_lignes_ok', 'action'],
        items: [],
        options: {
          headings: {
            date_import: 'Date traitement',
            nom_gestionnaire: 'Nom Prénom',
            profil_gestionnaire: 'Profil utilisateur',
            min_date_periode: 'Min date période',
            max_date_periode: 'Max date période',
            nom_fichier: 'Nom Fichier',
            nb_lignes_ok: 'Nb de lignes /\nStatut',
            action: 'Rapport',
          },
          perPage: 10,
          filterable: false,
          sortable: ['date_traitement', 'nom_gestionnaire', 'profil_gestionnaire', 'min_date_periode', 'max_date_periode', 'nom_fichier'],
          perPageValues: [10, 25, 50],
        },
      }
    },
    watch: {
      selectedTypes () {
        if (this.selectedTypes) {
          this.selectedTypeIds = this.selectedTypes.map( item => item.code)
        } else {
          this.selectedTypeIds = []
        }
      }
    },
    created() {
      this.getAllStatus();
      this.getAllType();
      this.all();
    },
    methods: {
      addFile(event) {
        this.attachment = event.target.files[0];
      },
      importFile() {
        if (this.validateData()) {
          let self = this;
          this.$store.commit("IS_LOADING", true);
          let formData = new FormData();
          formData.append('file', this.attachment);
          formData.append('status_id', this.statusId);
          formData.append('commentaire', this.commentaire);
          formData.append('types', this.selectedTypeIds);
          this.$axios
            .post(`/espaceGestion/module_prev/script-opc-bpij-by-nir`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
            .then((response) => {
              this.all();
              this.showRapport(response.data);
              this.$store.commit("IS_LOADING", false);
            })
            .catch((error) => {
              self.handleErrors(error);

            });
        }
      },
      showRapport(resultat) {
        this.nbLigneOk = resultat.nbLigneDone;
        this.nbLigneTotal = resultat.nbLigneTotal;
        this.rapportErrors = resultat.rapport;
        this.$refs['modal-rapport'].show();
      },
      getAllType() {
        return new Promise((resolve, reject) => {
          let self = this;

          this.$axios
          .get("/espaceGestion/dossier/getAllType")
          .then(response => {
            this.allTypes = response.data.data;
            for (let type of response.data.data) {
              this.typeOptions.push({code: type.id, name: type.libelle});
              if (type.libelle_technique === 'ij-bpij' || type.libelle_technique === 'bpijo' || type.libelle_technique === 'bpijp') {
                this.selectedTypes.push({code: type.id, name: type.libelle});
              }
            }
            resolve();
          })
          .catch((error) => {
            self.handleError(error);
            resolve();
          });
        })
      },
      getAllStatus() {
        return new Promise((resolve, reject) => {

          let self = this;
          let data = {
            libelle_categorie: 'status_dossier'
          }
          this.$axios
            .post("/administration/status/allStatutsByType", data)
            .then(response => {
              this.allStatus = response.data.allStatus;
              for (let status of response.data.statusTraite.sous_statuts) {
                if (status.libelle_technique === 'deja_traite' || status.libelle_technique === 'traite_credit_positif') {
                  this.statusOptions.push({value: status.id, text: status.libelle_bo})
                }
              }
              resolve();
            })
            .catch((error) => {
              console.log(error)
              self.handleErrors(self);
              resolve();
            });
        })
      },
      all() {
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .get("/espaceGestion/module_prev/getHistoriqueOpcBpij")
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.items = response.data.data;
            this.dataIsReady = true;
          })
          .catch(() => {
            this.handleErrors();
          });
      },
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      validateData() {
        this.clearErrors();
        let valid = true;

        if (isEmpty(this.attachment)) {
          this.errors.attachment = "Veuillez choisir un fichier";
          valid = false;
        }
        if (isEmpty(this.commentaire)) {
          this.errors.commentaire = "Veuillez saisir un commentaire à mettre dans le post-it";
          valid = false;
        }
        if (isEmpty(this.selectedTypes)) {
          this.errors.selectedTypes = "Veuillez choisir le type de dossier à prendre en compte";
          valid = false;
        }
        if (isEmpty(this.statusId)) {
          this.errors.statusId = "Veuillez sélectionner le statut à mettre aux dossiers";
          valid = false;
        }
        return valid;
      },
      clearErrors() {
        this.errors.attachment = "";
      },
      seeErrors(script) {
        let self = this;
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .get("/espaceGestion/module_prev/rapport-opc-bpij/"+script.id)
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            // On rajoute les données manquantes pour l'affichage (commun avec le retour d'import)
            let resultat = {
              rapport: response.data.data,
              nbLigneOk: script.nb_lignes_ok,
              nbLigneTotal: script.nb_lignes_total,
            }
            this.showRapport(resultat);
          })
          .catch((error) => {
            self.$store.commit("IS_LOADING", false);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur système est survenue, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 4000
            });
          });
      },
      download(script) {
        let fileNameArr = script.nom_fichier.trim().split('.');
        let ext = fileNameArr.pop();
        let name = fileNameArr.join('.');
        // let link = document.getElementById('pj_'+id);
        // link.style.color = 'violet';
        // console.log('link',link)
        this.$axios
          .get("/espaceGestion/module_prev/download-opc-file/"+script.id, {responseType: 'blob'})
          .then(response => {
            downloadFile(response, name, ext);
          })
          .catch(() => {
            this.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 4000
            });
          })
      },
      handleErrors(error) {
        console.log(error)
        let errorText = 'Une erreur est survenue. Si le problème persiste, merci de faire un ticket au support DOSI.'
        if (error.response !== undefined) {
          // console.log(error.response)
          errorText = error.response.data.message;
        }
        this.$store.commit('IS_LOADING', false);
        this.$swal({
          position: 'top',
          type: 'warning',
          title: 'Attention !!',
          text: errorText,
          showConfirmButton: false,
          timer: 4000,
        });
      },
      canExecute(rule) {
        return hasRule(rule);
      },
      displayPopup(type, title, text) {
        this.$swal({
          position: 'top',
          type: type,
          title: title,
          text: text,
          showConfirmButton: false,
          timer: 3000
        });
      },
    }
  }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
